import { Component, Input } from '@angular/core';
import { FormBaseComponent, ValidatorService } from '@utils-lib';
import { Internet } from '@nachdigal';
import { FormBuilder } from '@angular/forms';
import { DatevMessageService } from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-internet',
  templateUrl: './internet.component.html',
  styleUrls: ['./internet.component.scss']
})
export class InternetComponent extends FormBaseComponent<Internet> {

  @Input()
  public stammdatenInternetadressen: Array<Internet>;

  constructor(private readonly formBuilder: FormBuilder,
    private readonly validatorService: ValidatorService,
    protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    if (this.data instanceof Array && this.data.length > 0) {
      this.data = this.data[0];
    }

    this.form = this.formBuilder.group({
      internet: [this.data?.internet, [
        this.validatorService.minLength(1),
        this.validatorService.maxLength(128)
      ]],
      notiz: [this.data?.notiz]
    });
  }
}
